<wchfs-icon [svgIcon]="'pso:' + type + '_xl'" size="60"></wchfs-icon>
